import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const HOUSE = {
  nickname: 'PRODUCTS.HOUSE.shortname',
  LIST_OF_OBJECTS: ['houseAdditionalBuildings'],
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isHouseDamagesCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_OG_TYVERI' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    {
      name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    {
      name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.HOUSE', value: 'HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.TERRACED_HOUSE', value: 'TERRACED_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.DUPLEX', value: 'DUPLEX' }
        ]
      }
    },
    {
      name: 'houseSumInsuredType',
      key: 'SUM_INSURED_TYPE',
      group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      isFirstRiskSumInsuredCheck: true,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        ]
      }
    },
    { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.12', value: '12000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.18', value: '18000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.32', value: '32000' },
        ]
      }
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED_KOLIBRI', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.YES', value: 'true' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.NO', value: 'false' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.PARTIAL', value: 'PARTIAL' },
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'buildingProtected', key: 'BUILDING_PROTECTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
        ]
      }
    },
    { name: 'houseCella', key: 'HOUSE_CELLA', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingStandard', key: 'BUILDING_STANDARD', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.NORMAL', value: 'NORMAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.HIGH', value: 'HIGH' },
        ]
      }
    },
    {
      name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.1_BAD', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.2_BADS', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.3_AND_MORE_BADS', value: '3+' },
        ]
      }
    },
    {
      name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF_KOLIBRI', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_FLAT_ROOF.SLANTED_OR_SLOPED', value: 'SLANTED_OR_SLOPED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_FLAT_ROOF.FLAT', value: 'FLAT' },
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        {
          name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.SQUARE_METERS.10-30', value: '10-30' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.SQUARE_METERS.30-50', value: '30-50' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.SQUARE_METERS.50-100', value: '50-100' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.SQUARE_METERS.100+', value: '100+' },
            ]
          },
          validator: ['', [
            Validators.required
          ]]
        },
      ]
    },
    { name: 'moistureOrWaterDamage', key: 'MOISURE_OR_WATER_DAMAGE', group: 'INSURANCE_INFO', },
    { name: 'deficienciesOrErrorsOrDamages', key: 'DEFICIENCIES_OR_ERROR_OR_DAMAGES', group: 'INSURANCE_INFO', },
  ],
  icon: 'house'
};
